// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const move = (array: Array<any>, indexFrom: number, indexTo: number) => {
  const nextArray = [...array];

  nextArray.splice(indexTo, 0, nextArray.splice(indexFrom, 1)[0]);

  return nextArray;
};
